import SideNAvButtonGradient from 'component/Buttons/sidenav-btn'
import { useAgency } from 'context/agency'
import { useLocationInfo } from 'context/location'
import BasicinfoIcon from 'icon/basicinfo'
import GraphIcon from 'icon/graph'
import GroupIcon from 'icon/groupicon'
import ReportIcon from 'icon/kpi'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import NavDropdown from './nav-dropdown'
import NavItem from './nav-item'
import TopHeader from './top-header'
import ChartIcon from 'icon/chart'
import KeyIcon2 from 'icon/keyicon'
import { X } from 'lucide-react' // for close icon

const menu = [
  {
    label: 'Dashboard',
    path: './dashboard',
    icon: <GraphIcon />,
    key: 'dashboard',
  },
  {
    label: 'Accounts',
    path: './accounts/listing',
    icon: <GroupIcon />,
    key: 'accounts',
  },
  {
    label: 'Plans',
    path: './plans/listing',
    icon: <ChartIcon />,
    key: 'plans',
  },
  {
    label: 'Reports',
    icon: <ReportIcon />,
    key: 'reports',
    children: [
      {
        label: 'Transactions Report',
        path: './transactionsreport',
        // icon: <ReportIcon />,
        key: 'transactionsreport',
      },
      {
        label: 'Client Activity Report',
        path: './clientactivityreport',
        // icon: <ReportIcon />,
        key: 'clientactivityreport',
      },
      {
        label: 'Notification Report',
        path: './notificationreport',
        // icon: <ReportIcon />,
        key: 'notificationreport',
      },
    ],
  },
  // {
  //   label: 'Review Products',
  //   icon: <StarIcon />,
  //   key: 'review_products',
  //   children: [
  //     {
  //       label: 'Products',
  //       path: '.',
  //       icon: <CampaignsIcon />,
  //       key: 'products',
  //     },
  //     {
  //       label: 'Smart Forms',
  //       path: '.',
  //       icon: <CampaignsIcon />,
  //       key: 'smart_forms',
  //     },
  //   ],
  // },
  // {
  //   label: 'Loyalty Cards',
  //   icon: <CrownIcon />,
  //   key: 'loyalty_cards',
  //   children: [
  //     {
  //       label: 'Campaigns',
  //       path: './campaigns',
  //       icon: <MobileScreenIcon size={5} />,
  //       // <CampaignsIcon />
  //       key: 'campaign',
  //     },
  //     {
  //       label: 'Customers',
  //       path: './customers',
  //       icon: <GroupIcon />,
  //       key: 'customer',
  //     },
  //     {
  //       label: 'Scanner',
  //       path: './scanner',
  //       icon: <ScanIcon />,
  //       key: 'scanner',
  //     },
  //     {
  //       label: 'Notifications',
  //       path: './broadcast',
  //       icon: <MessageIcon2 />,
  //       key: 'brodcast',
  //     },
  //     {
  //       label: 'Geo Locations',
  //       path: './geo-location',
  //       icon: <LocationIcon />,
  //     },
  //   ],
  // },

  // {
  //   label: 'GrowthTool',
  //   path: './growthtool',
  //   icon: <ChartIcon />,
  // },
]

const settings = [
  {
    label: 'General Info',
    path: './settings/generalinfo',
    icon: <BasicinfoIcon />,
  },
  {
    label: 'Integrations',
    path: './settings/integration',
    icon: <KeyIcon2 />,
  },
  // {
  //   label: 'Billing',
  //   path: './settings/billings',
  //   icon: <BillIcon />,
  // },
  // {
  //   label: 'ApiKey',
  //   path: './settings/apikey',
  //   icon: <KeyIcon2 />,
  // },
]

function Sidebar() {
  const { agency } = useAgency()
  const { saasPlan } = useLocationInfo()
  const [openSideMenu, setOpenSideMenu] = useState(false)
  const [showSettings, setShowSettings] = useState(
    window.location.pathname.includes('settings')
  )
  const [filteredMenu, setFilteredMenu] = useState(menu)
  const navigate = useNavigate()

  const sidenav_bg_color = '#7474f5'
  const page_color = agency.location_config?.page_bg_color

  const handleNavigate = (path) => {
    navigate(path)
    setOpenSideMenu(false)
  }

  const renderItem = (menu_item) => (
    <div key={menu_item.label}>
      {menu_item.children ? (
        <NavDropdown {...menu_item} onNavigate={handleNavigate} />
      ) : (
        <NavItem
          {...menu_item}
          onClick={() => handleNavigate(menu_item.path)}
          active={window.location.pathname === menu_item.path}
        />
      )}
    </div>
  )

  useEffect(() => {
    if (saasPlan?.features?.length) {
      const filtered = menu.filter((item) =>
        saasPlan.features.find((key) => key.includes(item.key))
      )
      setFilteredMenu(filtered)
    }
  }, [saasPlan])

  return (
    <div>
      {/* ✅ Top Navbar */}
      <nav
        style={{ backgroundColor: page_color }}
        className='pt-3 w-full md:w-[calc(100%-329px)] ml-0 md:ml-[292px]'
      >
        <div className='bg-white border-b border-gray-200 rounded-t-3xl'>
          <div className='px-3 py-3 flex items-center justify-between'>
            {/* ✅ Mobile Menu Button */}
            <button
              type='button'
              className='inline-flex items-center p-2 text-gray-600 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none'
              onClick={() => setOpenSideMenu(true)}
            >
              <svg
                className='w-6 h-6'
                fill='currentColor'
                viewBox='0 0 20 20'
                aria-hidden='true'
              >
                <path
                  clipRule='evenodd'
                  fillRule='evenodd'
                  d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 
                  010 1.5H2.75A.75.75 0 012 4.75zm0 
                  10.5a.75.75 0 01.75-.75h7.5a.75.75 0 
                  010 1.5h-7.5a.75.75 0 01-.75-.75zM2 
                  10a.75.75 0 01.75-.75h14.5a.75.75 0 
                  010 1.5H2.75A.75.75 0 012 10z'
                />
              </svg>
            </button>
            <TopHeader />
          </div>
        </div>
      </nav>

      {/* ✅ Mobile Overlay */}
      {openSideMenu && (
        <div
          onClick={() => setOpenSideMenu(false)}
          className='fixed inset-0 bg-black/50 z-40 md:hidden'
        ></div>
      )}

      {/* ✅ Sidebar */}
      <aside
        style={{ backgroundColor: sidenav_bg_color }}
        className={`fixed top-0 left-0 z-50 transition-transform duration-300 ease-in-out
        ${openSideMenu ? 'translate-x-0' : '-translate-x-full'} 
        w-full md:w-64 h-[100dvh] md:h-[calc(100dvh-24px)] md:mt-3 md:left-3 
        md:translate-x-0 rounded-none md:rounded-3xl`}
      >
        {/* ✅ Mobile Header */}
        <div className='flex justify-between items-center p-4 border-b border-white/20 md:hidden'>
          <h2 className='text-white text-lg font-semibold'>Super Admin</h2>
          <button onClick={() => setOpenSideMenu(false)}>
            <X className='text-white w-6 h-6' />
          </button>
        </div>

        {/* ✅ Desktop Header */}
        <div className='hidden md:flex min-h-[67px] flex-col justify-center items-center rounded-t-3xl mb-2'>
          <span className='mt-2 w-36 text-xl truncate text-white font-semibold sm:text-2xl text-center'>
            Super Admin
          </span>
        </div>

        {/* ✅ Sidebar Content */}
        <div className='flex flex-col justify-between h-[calc(100%-70px)] px-3 pb-4 overflow-y-auto'>
          <div>
            {showSettings && (
              <div className='my-3'>
                <SideNAvButtonGradient
                  type='button'
                  onClick={() => {
                    setShowSettings(false)
                    navigate('/')
                    setOpenSideMenu(false)
                  }}
                  className='w-full pb-2'
                >
                  Go Back
                </SideNAvButtonGradient>
              </div>
            )}

            <ul className='space-y-2 font-medium'>
              {(showSettings ? settings : filteredMenu).map((menu_item) =>
                renderItem(menu_item)
              )}
            </ul>
          </div>

          {/* ✅ Settings Button - Centered on mobile */}
          {!showSettings && (
            <div className='flex justify-center mt-6 md:mt-0 md:px-4'>
              <SideNAvButtonGradient
                type='button'
                onClick={() => {
                  setShowSettings(true)
                  navigate('./settings/')
                  setOpenSideMenu(false)
                }}
                className='w-11/12 md:w-full pb-2'
              >
                Settings
              </SideNAvButtonGradient>
            </div>
          )}
        </div>
      </aside>
    </div>
  )
}
export default Sidebar
